export * from './login-form.component';



// WEBPACK FOOTER //
// ./src/app/login/login-form/index.ts